import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import {
  Translation,
  translocoConfig,
  TranslocoLoader,
  TranslocoModule,
  provideTransloco,
} from '@jsverse/transloco';
import Helpers from 'src/shared/helpers';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    return this.http.get<Translation>(`api/common/i18n/${lang}`);
  }
}

export const translocoConf = translocoConfig({
  availableLangs: ['hu-HU', 'en-US'],
  defaultLang: Helpers.getSavedLangOrDefault(),
  fallbackLang: 'en-US',
  reRenderOnLangChange: true,
  prodMode: false,
  missingHandler: { useFallbackTranslation: true },
});

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: translocoConf,
      loader: TranslocoHttpLoader,
    }),
  ],
})
export class TranslocoRootModule {}
